import { plants } from "../Display";

function Plant({ scientificName, commonName, img, onClick } : { scientificName: string, commonName: string, img: string, onClick?: () => void }) {
    return (
        <button className='plant border-none flex flex-col p-8 items-center gap-4 rounded-lg justify-center hover:-translate-y-2 transition-transform' onClick={onClick}>
            <h3 className="italic text-xl">{scientificName}</h3>
            <h2 className="text-xl">{commonName}</h2>
            <div className="max-h-80">
                <img src={img} alt={commonName} className="max-h-full pixelated" />
            </div>
        </button>
    );
}

export default function Plants({ next }: { next: [() => void, () => void, () => void]}) {
    return (
        <div className='displayBox grid grid-flow-col h-full p-8 gap-x-8 grid-cols-3'>
            {
                plants.map((plant, i) => (
                    <Plant 
                        scientificName={plant.scientificName}
                        commonName={plant.commonName}
                        img={plant.img}
                        onClick={next[i]}
                    />
                ))
            }
        </div>
    );
}